/**
 * FluxoCaixaLayout.tsx — Casca do módulo único "Fluxo de Caixa".
 *
 * Consolida a família de caixa (decisão do usuário 2026-09-02): Fluxo de Caixa,
 * Fluxo Projetado (ex-Matriz), Necessidade de Caixa, Cenários, Contas a Receber,
 * Contas a Pagar, Recebimentos e Importação de Pagamentos deixam de ser oito
 * itens soltos no menu e passam a ser ABAS de uma única página.
 *
 * A casca é só navegação: renderiza a barra de abas (reusa o primitivo Tabs, com
 * role tablist/tab) e delega o conteúdo de cada aba ao <Outlet /> — cada sub-tela
 * continua sendo sua própria rota (deep-link preservado) com seu próprio guard e
 * PageHeader. Nada de conteúdo é reimplementado aqui.
 *
 * A aba ativa vem do pathname (useLocation já vem sem o basename /orbita/app).
 */

import { Outlet, useLocation, useNavigate } from "react-router";
import { Tabs } from "@/components/ui";

interface AbaCaixa {
  readonly id: string;
  readonly label: string;
  readonly path: string;
}

/** Ordem das abas = ordem de leitura da família de caixa. */
const ABAS: readonly AbaCaixa[] = [
  { id: "fluxo-caixa",           label: "Fluxo de Caixa",          path: "/app/financeiro/fluxo-caixa" },
  { id: "fluxo-matriz",          label: "Fluxo Projetado",         path: "/app/financeiro/fluxo-matriz" },
  { id: "necessidade-de-caixa",  label: "Necessidade de Caixa",    path: "/app/financeiro/necessidade-de-caixa" },
  { id: "cenarios",              label: "Cenários",                path: "/app/financeiro/cenarios" },
  { id: "contas-a-receber",      label: "Contas a Receber",        path: "/app/financeiro/contas-a-receber" },
  { id: "contas-a-pagar",        label: "Contas a Pagar",          path: "/app/financeiro/contas-a-pagar" },
  { id: "recebimentos",          label: "Recebimentos",            path: "/app/financeiro/recebimentos" },
  { id: "importacao-pagamentos", label: "Importação de Pagamentos", path: "/app/financeiro/importacao-pagamentos" },
];

export function FluxoCaixaLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const ativa =
    ABAS.find((a) => location.pathname === a.path || location.pathname.startsWith(a.path + "/"))?.id ??
    "fluxo-caixa";

  return (
    <>
      <div style={{ maxWidth: "1080px", margin: "0 auto", padding: "1.5rem 1rem 0" }}>
        <Tabs
          items={ABAS}
          active={ativa}
          onChange={(id) => {
            const aba = ABAS.find((a) => a.id === id);
            if (aba) void navigate(aba.path);
          }}
        />
      </div>
      <Outlet />
    </>
  );
}
